/**
 * Ad Configuration Utility
 *
 * Deshabilita automáticamente los anuncios en modo desarrollo/local
 * para evitar que Google interprete los clics de prueba como tráfico
 * no válido, lo cual podría afectar la monetización de AdSense.
 */

/**
 * Determina si los anuncios deben mostrarse.
 * Retorna `false` cuando:
 *  - Vite está en modo development (`import.meta.env.DEV`)
 *  - El hostname es localhost, 127.0.0.1, 0.0.0.0, o cualquier IP privada
 */
export function isAdsEnabled(): boolean {
  // Vite inyecta import.meta.env.DEV como true en `vite dev`
  if (import.meta.env.DEV) {
    return false;
  }

  // Comprobación adicional por hostname (por si se sirve un build de producción localmente)
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    const localHosts = ['localhost', '127.0.0.1', '0.0.0.0', '::1'];

    if (localHosts.includes(hostname)) {
      return false;
    }

    // Detectar IPs privadas (192.168.x.x, 10.x.x.x, 172.16-31.x.x)
    if (
      /^192\.168\.\d+\.\d+$/.test(hostname) ||
      /^10\.\d+\.\d+\.\d+$/.test(hostname) ||
      /^172\.(1[6-9]|2\d|3[01])\.\d+\.\d+$/.test(hostname)
    ) {
      return false;
    }
  }

  return true;
}

/**
 * Indica si estamos en un entorno de desarrollo.
 * Útil para mostrar placeholders visuales donde irían los anuncios.
 */
export function isDevEnvironment(): boolean {
  return !isAdsEnabled();
}
